import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";

const initialState = {
    addAddress: [],
    oneAddress:[],
    allAddress: [],
    deleteAddress: [],
    editAddress: [],
    userData: [],
    editUserData: [],
    editUserPassword: [],
    isLoading: true,
    isSuccess: true,
    errorMessage: ""
}

// Add User Address
export const AddAddress = createAsyncThunk("user/AddAddress", async (data) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.post("/api/v1/addresses", data, config);
        return res;
    } catch (error) {
        return error;
    }
})

// get all User Address
export const GetAllAddress = createAsyncThunk("userAddress/getAll", async () => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.get("/api/v1/addresses", config);
        return res;
    } catch (error) {
        return error;
    }
})


// delete one address
export const DeleteOneAddress = createAsyncThunk("userAddress/deleteOne", async (id) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.delete(`/api/v1/addresses/${id}`, config);
        return res;
    } catch (error) {
        return error;
    }
})


// delete one address
export const EditUserAddress = createAsyncThunk("userAddress/EditOne", async ({ id, data }) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.put(`/api/v1/addresses/${id}`, data, config);
        return res;
    } catch (error) {
        return error;
    }
})

// get user Data
export const GetUserData = createAsyncThunk("user/getData", async () => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.get("/api/v1/users/getMe", config);
        return res;
    } catch (error) {
        return error;
    }
})

// edit user Data
export const EditUserData = createAsyncThunk("user/EditData", async (data) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.put("/api/v1/users/updateMe", data, config);
        return res;
    } catch (error) {
        return error;
    }
})

// edit user Password
export const EditUserPassword = createAsyncThunk("user/EditPassword", async (data) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.put("/api/v1/users/changeMyPassword", data, config);
        return res;
    } catch (error) {
        return error;
    }
})

// get address details
export const getOneAddress = createAsyncThunk("user/getOneAddress", async (id) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.get(`/api/v1/addresses/${id}`, config);
        return res;
    } catch (error) {
        return error;
    }
})



const UserSlice = createSlice({
    name: "UserAddress",
    initialState,
    reducers: {},
    extraReducers: {
        [AddAddress.pending]: (state, action) => {
            state.isLoading = true
        },
        [AddAddress.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.addAddress = action.payload
        },
        [AddAddress.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [GetAllAddress.pending]: (state, action) => {
            state.isLoading = true
        },
        [GetAllAddress.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.allAddress = action.payload
        },
        [GetAllAddress.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [DeleteOneAddress.pending]: (state, action) => {
            state.isLoading = true
        },
        [DeleteOneAddress.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.deleteAddress = action.payload
        },
        [DeleteOneAddress.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [EditUserAddress.pending]: (state, action) => {
            state.isLoading = true
        },
        [EditUserAddress.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.editAddress = action.payload
        },
        [EditUserAddress.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [GetUserData.pending]: (state, action) => {
            state.isLoading = true
        },
        [GetUserData.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.userData = action.payload
        },
        [GetUserData.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [EditUserData.pending]: (state, action) => {
            state.isLoading = true
        },
        [EditUserData.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.editUserData = action.payload
        },
        [EditUserData.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [EditUserPassword.pending]: (state, action) => {
            state.isLoading = true
        },
        [EditUserPassword.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.editUserPassword = action.payload
        },
        [EditUserPassword.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [getOneAddress.pending]: (state, action) => {
            state.isLoading = true
        },
        [getOneAddress.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.oneAddress = action.payload
        },
        [getOneAddress.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        }
    }
})

export default UserSlice.reducer;